exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cs-SummaryDropDown {\n  display: table;\n  width: 100%;\n}\n.cs-SummaryDropDown__Question {\n  border-right: 1px solid #ddd;\n  display: table-cell;\n  width: 60%;\n  padding: 5px;\n}\n.cs-SummaryDropDown__Answer {\n  border-right: 1px solid #ddd;\n  display: table-cell;\n  width: 20%;\n  padding: 5px;\n}\n.cs-SummaryDropDown__Points {\n  display: table-cell;\n  width: 20%;\n  padding: 5px;\n}\n.cs-SummaryDropDown__Border {\n  border-bottom: 1px solid #ddd;\n  display: inherit;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/SurveySummary/SummaryDropDown/SummaryDropDown.less
// module id = 951
// module chunks = 0